const group_types = ['Private', 'Charity', 'Community', 'Business'];

const pressed_opacity = 0.9;
const opacity_50 = 0.5;

export { group_types, pressed_opacity }